import React from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { Box, Text } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { AnnouncerV2 } from '@atlassian/jira-accessibility/src/ui/announcer-v2/index.tsx';
import { Fill } from '@atlassian/jira-common-components-skeleton/src/fill.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { SearchField } from '@atlassian/jira-searchfield/src/index.tsx';
import { LOADING } from '../../../constants.tsx';
import type { SidebarFilterComponentProps } from '../../../types.tsx';
import { messages } from './messages.tsx';

export const FilterEfa = ({
	onChange,
	asyncState,
	filter,
	totalAvailableItemsCount,
	disabledReason,
}: SidebarFilterComponentProps) => {
	const { formatMessage } = useIntl();
	const onSearchFieldChange = (searchTerm: string, analyticsEvent?: UIAnalyticsEvent) =>
		onChange({ name: searchTerm }, analyticsEvent);
	const message = filter.name ? messages.matchingItemsCount : undefined;

	return (
		<Box>
			<Text size="small">{formatMessage(messages.filterLabel)}</Text>
			{disabledReason === undefined ? (
				<>
					<SearchField
						key="filter"
						value={filter.name}
						onChange={onSearchFieldChange}
						isAutocompleteDisabled
						placeholder={formatMessage(messages.filterPlaceholder)}
						shouldFitContainerWidth
						// placeholder for SearchField is hidden by default, so we have to override it
						placeholderAlwaysVisible
					/>
					{asyncState === LOADING ? (
						<Fill />
					) : (
						message && (
							<Text size="small" color="color.text.subtle">
								{formatMessage(message, { count: totalAvailableItemsCount })}
							</Text>
						)
					)}
					{message && (
						<AnnouncerV2
							message={formatMessage(message, { count: totalAvailableItemsCount })}
							shouldAnnounce={asyncState !== LOADING}
						/>
					)}
				</>
			) : (
				<Tooltip content={formatMessage(disabledReason)}>
					<SearchField
						key="filter"
						value={filter.name}
						onChange={onSearchFieldChange}
						isAutocompleteDisabled
						placeholder={formatMessage(messages.filterPlaceholder)}
						shouldFitContainerWidth
						// placeholder for SearchField is hidden by default, so we have to override it
						placeholderAlwaysVisible
						isDisabled
					/>
				</Tooltip>
			)}
		</Box>
	);
};
